import { Col, Grid, Row } from 'antd';
import CardC from 'src/components/Card';
import ImageC from 'src/components/Image';
import textConstant from 'src/constants/textTenagaKesehatan';
import FormTenagaKesehatan from 'src/containers/Forms/TenagaKesehatan';

import classes from './index.module.css';
import cn from "src/utils/cn";

const PageContainerTenagaKesehatan = () => {
	const { xs } = Grid.useBreakpoint();

	return (
		<div className={classes['container-page']}>
			<div className="container">
				<Row gutter={32}>
					<Col className={cn({ 'p-0': xs })} lg={10} md={24} sm={24} xs={24}>
						<CardC>
							<div className={classes['form-greeting']}>
								<h3>{textConstant.TENAGA_KESEHATAN.PAGE_GREETING}</h3>
								<p>{textConstant.TENAGA_KESEHATAN.PAGE_GREETING_DESC}</p>
							</div>
							<FormTenagaKesehatan />
						</CardC>
					</Col>
					<Col lg={14} md={24} sm={24} xs={24}>
						<div className={classes['image-content']}>
							<ImageC
								alt="Icon Tenaga Kesehatan"
								src="/images/tenaga_kesehatan/tenaga-kesehatan.svg"
								style={{ objectFit: 'contain' }}
								layout="fill"
							/>
						</div>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default PageContainerTenagaKesehatan;
